module.exports = ".loginout {\r\n\r\n}\r\n\r\n.loginout-button {\r\n    vertical-align:middle;\r\n    width:auto !important;\r\n    display:inline !important;\r\n}\r\n\r\n.loginout-text {\r\n    vertical-align:middle;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/security/loginout/loginout.component.css
// module id = ./src/app/security/loginout/loginout.component.css
// module chunks = main